import {field} from "../../stem-core/state/StoreField";
import {BaseLogMessage} from "./misc/BaseLogMessage";
import {BaseStore, globalStore} from "../../stem-core/state/Store";


@globalStore
export class BlinkLogMessage extends BaseStore("BlinkLogMessage", {}, BaseLogMessage) {
    @field(String) app: string;
    @field(String) hostname: string;
    // Sent by the API but never mirrored here; `declare` keeps the emitted class unchanged
    declare filename: string;
    declare lineno: number;
    declare exceptionInfo: string;
}
